import type { LeadStage } from "@shared-core/data/api-types";
import { LEAD_STAGE_LABELS } from "@shared-core/domain/leads";
import { Badge } from "../../primitives/badge";

const STAGE_VARIANT: Record<
  LeadStage,
  "neutral" | "warning" | "error" | "secondary" | "success"
> = {
  cold: "neutral",
  warm: "warning",
  hot: "error",
  contact_made: "secondary",
  quoted: "secondary",
  follow_up: "warning",
  first_order: "success",
};

export function LeadStageBadge({ stage }: { stage: LeadStage }) {
  return (
    <Badge variant={STAGE_VARIANT[stage]}>{LEAD_STAGE_LABELS[stage]}</Badge>
  );
}
